import React, { useContext, useEffect, useState } from "react";
import { Content } from "../components/Content";
import { contextApi } from "../context/contextApi";
import { Loading } from "../components/common/Loading";
import { useWalletAssets } from "../hooks/useWalletAssets";

export const WalletRialVip = () => {
  const context = useContext(contextApi);
  const { boxes } = useWalletAssets(1);
  const [isDark, setIsDark] = useState(
    () =>
      typeof window !== "undefined" && document.body.classList.contains("dark")
  );

  useEffect(() => {
    const checkDark = () => setIsDark(document.body.classList.contains("dark"));
    checkDark();
    const observer = new MutationObserver(() => {
      checkDark();
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="flex flex-row h-full basis-full bg-white dark:bg-[#0D1117]">
      <Loading show={context.load} />
      <Content boxes={boxes} id={1} pageName="کیف  ریالی VIP" />
    </div>
  );
};
